<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="轮播模块：" prop="Plate">
          <p>{{ dataForm.Plate }}</p>
        </el-form-item>
        <el-form-item label="图片：" prop="Files">
          <p v-if="dataForm.Plate == '新闻轮播图'">
            提示：宽度：810像素，高度：180像素
          </p>
          <p v-else-if="dataForm.Plate === '手机轮播图'">
            提示：宽度：750像素，高度：483像素
          </p>
          <p v-else>提示：宽度：1920像素，高度：300像素</p>
          <div v-for="(item, index) in picList" :key="index">
            <of-upload
              class="upload-demo"
              :limit="limitNum"
              list-type="picture-card"
              @onPreview="onPreview"
              @onRemove="onRemove"
              @onUpLoad="uploadPictures"
              @onCheckFile="onCheckFile"
              @onExceed="onExceed"
              :fileList="item.data"
              :class="{ hide: item.hide }"
            >
              <div
                slot="content"
                style="margin-bottom: 20px"
                @click="setIndex(index)"
              >
                <i slot="default" class="el-icon-plus"></i>
              </div>
            </of-upload>
            <div
              style="
                height: 148px;
                float: left;
                margin-left: 15px;
                cursor: pointer;
              "
            >
              <i
                class="el-icon-top"
                style="line-height: 148px; font-size: 200%; float: left"
                @click="up(index)"
                v-if="index != 0"
              ></i>
              <i
                class="el-icon-bottom"
                style="line-height: 148px; font-size: 200%"
                @click="down(index)"
                v-if="index != 4"
              ></i>
            </div>
          </div>
          <el-dialog
            :visible.sync="dialogVisible"
            width="100%"
            :append-to-body="true"
          >
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        Plate: [{ required: true, message: "轮播模块不能空", trigger: "blur" }],
      },
      isConfirm: false,
      pictureList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      limitNum: 1,
      plate: "OF.SlideShow",
      index: "", //轮播图标识
      //upload组件数据
      picList: [
        { hide: false, data: [] },
        { hide: false, data: [] },
        { hide: false, data: [] },
        { hide: false, data: [] },
        { hide: false, data: [] },
      ],
    };
  },
  mounted() {
    this.getlistImg();
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce,
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onCheckFile(file, status) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$message({
          type: "error",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
        status(false);
        return;
      }
      let size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          type: "error",
          message: "图片大小必须小于10M",
        });
        status(false);
        return;
      }
    },
    onExceed() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error",
      });
    },
    uploadPictures(file) {
      if (file.response.Code === 0) {
        this.$message({
          message: "上传图片成功",
          type: "success",
        });
        this.pictureList[this.index] = {
          url: '/files'+file.response.Data.StorePath,
          id: file.response.Data.FileId,
        };
        this.picList[this.index].hide = true;
        let data = [];
        data.push(this.pictureList[this.index]);
        this.picList[this.index].data = data;
        let files = [];
        this.pictureList.forEach((item, index) => {
          if (item && item.id) {
            files.push(item);
          }
        });
        this.dataForm.Files = JSON.stringify(files);
      }
    },
    onRemove(file) {
      for (let i = 0; i < this.pictureList.length; i++) {
        if (this.pictureList[i] && this.pictureList[i].url == file.url) {
          this.pictureList[i] = {};
          this.picList[i].hide = false;
          this.picList[i].data = [];
        }
        let data = [];
        this.pictureList.forEach((item, index) => {
          if (item && item.id) {
            data.push(item);
          }
        });
        this.dataForm.Files = JSON.stringify(data);
      }
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          this.dataForm.CreatorId = this.GetCurrentUserInfo.Id;
          let params = Object.assign({}, this.dataForm);
          api
            .saveSlideShow(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    getlistImg() {
      if (this.dataForm.Files === undefined || this.dataForm.Files === null) {
        return;
      }
      let files = JSON.parse(this.dataForm.Files);
      if (files.length >= this.limitNum) {
        this.hideUploadEdit = true;
      }

      this.pictureList = files.map((item) => {
        return {
          url: item.url,
          id: item.id,
        };
      });
      this.pictureList.forEach((item, index) => {
        this.picList[index].hide = true;
        this.picList[index].data.push(item);
      });
    },
    //设置轮播图标识
    setIndex(value) {
      this.index = value;
    },
    down(value) {
      if (this.pictureList[value]) {
        let pic = this.pictureList[value];
        this.pictureList[value] = this.pictureList[value + 1];
        this.pictureList[value + 1] = pic;
        if (!this.picList[value + 1].hide) {
          this.picList[value + 1].hide = true;
          this.picList[value].hide = false;
          let data = [];
          data.push(pic);
          this.picList[value + 1].data = data;
          this.picList[value].data = [];
        } else {
          let data = this.picList[value].data;
          this.picList[value].data = this.picList[value + 1].data;
          this.picList[value + 1].data = data;
        }
        let data = [];
        this.pictureList.forEach((item, index) => {
          if (item && item.id) {
            data.push(item);
          }
        });
        this.dataForm.Files = JSON.stringify(data);
      }
    },
    up(value) {
      if (this.pictureList[value]) {
        let pic = this.pictureList[value];
        this.pictureList[value] = this.pictureList[value - 1];
        this.pictureList[value - 1] = pic;
        if (!this.picList[value - 1].hide) {
          this.picList[value - 1].hide = true;
          this.picList[value].hide = false;
          let data = [];
          data.push(pic);
          this.picList[value - 1].data = data;
          this.picList[value].data = [];
        } else {
          let data = this.picList[value].data;
          this.picList[value].data = this.picList[value - 1].data;
          this.picList[value - 1].data = data;
        }
        let data = [];
        this.pictureList.forEach((item, index) => {
          if (item && item.id) {
            data.push(item);
          }
        });
        this.dataForm.Files = JSON.stringify(data);
      }
    },
  },
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.upload-demo >>> .el-upload-list__item {
  width: 480px !important;
  transition: none !important;
}
.upload-demo >>> .el-upload--picture-card {
  width: 480px !important;
  float: left;
  margin-bottom: 20px;
}
.upload-demo {
  float: left;
}
</style>

<style>
.hide .el-upload--picture-card {
  display: none;
}
.hide {
  display: block !important;
}
</style>